// extracted by mini-css-extract-plugin
module.exports = {"container":"c59J36Ir","checkList":"_3dXjQhKt","list":"_1PH0EXdW","item":"_3bOYc_5X","icon":"_24u13_zO","button":"_1HBxq2Tl","headingText":"_10ZOfJMC"};